import { Box } from "@mui/material";
import React from "react";
import CircularProgress from "@mui/material/CircularProgress"; // circularProgressClasses,
import logo from "Assets/Company/logo.png";

const SuspanceLoading = () => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: ".5rem",
        }}
      >
        <Box sx={{ height: "3.5rem", width: "3.5rem" }}>
          <img
            src={logo}
            alt="No Preview"
            style={{ height: "100%", width: "100%", objectFit: "contain" }}
            onError={(e) => {
              e.onerror = null;
              e.target.src = require("Assets/Company/logo.png");
            }}
          />
        </Box>
        <svg width={0} height={0}>
          <defs>
            <linearGradient id="my_gradient" x1="0%" y1="0%" x2="0%" y2="100%">
              <stop offset="0%" stopColor="#e01cd5" />
              <stop offset="100%" stopColor="#1CB5E0" />
            </linearGradient>
          </defs>
        </svg>
        <CircularProgress
          size={45}
          disableShrink
          thickness={4}
          sx={{ "svg circle": { stroke: "url(#my_gradient)" } }}
        />
      </Box>
    </Box>
  );
};

export default SuspanceLoading;
